module.exports = __webpack_public_path__ + "static/img/female-4.7df05470.png";